import React from 'react'
import { useTranslation } from 'react-i18next'

const TopBarLogo = () => {
  const { i18n } = useTranslation()
  return (
    <div className="h-16 flex flex-col items-center justify-center lg:items-start px-16 md:px-24 bg-white">
      <a href={`${process.env.REACT_APP_WEBSITE}/${i18n.language}`}>
        <img src="https://cdn-website-assets.s3.eu-central-1.amazonaws.com/assets/zappy-logo.png" className="h-8" />
      </a>
    </div>
  )
}

export default TopBarLogo
